import {
  CalligraphyLayoutSkeleton,
  SuspensePageBoundary,
} from "@-/dev.improve.haniverse.components.ui.suspense-page";
import { GraphemeInfoCaligraphyScreenSuspense } from "#grapheme-info-caligraphy-screen-suspense";

export function GraphemeInfoCaligraphyScreen({ grapheme }: { grapheme: string }) {
  return (
    <SuspensePageBoundary fallback={<CalligraphyLayoutSkeleton />} location={import.meta.location}>
      <GraphemeInfoCaligraphyScreenSuspense character={grapheme} />
    </SuspensePageBoundary>
  );
}
